module.exports = __webpack_public_path__ + "static/1-51fb332ba01fe7a1ec0375b886e4c830.jpg";